import React from 'react';
import { NumericFormat } from 'react-number-format';
import { ErrMessage } from '../messages';

export const CustomNumericFormat = ({
    handleChangeMiles,
    name,
    placeholder,
    label,
    value,
    error,
    errorName,
    thousandSeparator,
    fixedDecimalScale,
    decimalScale,
    prefix,
    styles,
    disabled,
    className,
    noError,
}) => {
    return (
        <div className="custom-numeric-format-box">
            <p className={value ? 'numeric-autocomplete-label-active' : 'numeric-autocomplete-label'}>{label}</p>
            <NumericFormat
                disabled={disabled}
                style={{ ...styles }}
                className={className ? className : errorName === name ? 'numeric-format-input-error' : 'numeric-format-input'}
                value={value}
                onValueChange={handleChangeMiles}
                name={name}
                thousandSeparator={thousandSeparator}
                fixedDecimalScale={fixedDecimalScale}
                decimalSeparator="."
                allowNegative={false}
                isNumericString
                prefix={prefix ? prefix : ''}
                placeholder={placeholder}
                decimalScale={decimalScale}
            />
            {!noError && <ErrMessage text={errorName === name ? error : ''} />}
        </div>
    );
};
